/**
 * PCK-655: the legacy sign-in page's Remember me cookies, used to seed this page the first
 * time a user arrives here. They expire after a day and nothing refreshes them once the
 * legacy page is redirected away, so this is a one-off migration seed, not a store.
 */
const COMPANY_COOKIE = 'CompanyLoginId'
const USERNAME_COOKIE = 'Username'

function readCookie(name) {
  const prefix = `${name}=`
  const entry = document.cookie.split('; ').find(c => c.startsWith(prefix))
  if (!entry) return ''

  const raw = entry.slice(prefix.length)
  try {
    return decodeURIComponent(raw).trim()
  } catch (e) {
    return raw.trim() // malformed encoding - the raw value beats nothing
  }
}

// Either field is blank when its cookie is missing, empty or whitespace-only.
export function readLegacyRememberedLogin() {
  return {
    companyLoginId: readCookie(COMPANY_COOKIE),
    username: readCookie(USERNAME_COOKIE)
  }
}
